import { component_tool, framework_tool } from '@/tool';
let { WizModal, WizNotice } = component_tool;
import moment from "moment";

let ref;
//配置项
let componentName = 'interactLive'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "直播名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "直播类型",
    name: "liveType",
    dataIndex: "liveType",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 1, codeName: "视频直播" },
      // { code: 2, codeName: "互动直播" },
      // { code: 3, codeName: "点播" },
      // { code: 4, codeName: "远程认证" },
      // { code: 5, codeName: "直播课堂" },
      // { code: 6, codeName: "远程评估" },
    ],
  },
  {
    title: "观看类型",
    name: "watchType",
    dataIndex: "watchType",
    tableItem: {},
    searchItem: {
      type: 'select',
    },
    dict: [
      { code: 1, codeName: "横屏" },
      { code: 2, codeName: "竖屏" },
    ],
  },

  {
    title: "直播分类",
    name: "categoryName",
    dataIndex: "categoryName",
    tableItem: {}
  },

  {
    title: "开播时间",
    name: "startDate",
    dataIndex: "startDate",
    width: 150,
    tableItem: {}
  },
  {
    title: "直播状态",
    name: "stateList",
    dataIndex: "state",
    searchItem: {
      type: 'select',
      mode: 'multiple',
      formatInit: () => [1,2,3]
    },
    dict: [
      { code: 1, codeName: "草稿" },
      { code: 2, codeName: "预告中" },
      { code: 3, codeName: "直播中" },
      { code: 4, codeName: "已结束" }
    ],
  },
 {
    title: "直播状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 1, codeName: "草稿" },
      { code: 2, codeName: "预告中" },
      { code: 3, codeName: "直播中" },
      { code: 4, codeName: "已结束" }
    ],
  }, 
  {
    title: "开播时间",
    name: "searchDate",
    dataIndex: "searchDate",
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  }

];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: (val) => {
          if (val['searchDate'] && val['searchDate'].length === 2) {
            val['startDate'] = moment(val['searchDate'][0]).format("YYYY-MM-DD")
            val['endDate'] = moment(val['searchDate'][1]).format("YYYY-MM-DD")
          }
          // delete val['searchDate']
          return val
        },
        buttonSort: [],
        buttons: [
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: false,
        isScroll: true,
        loading: false,
      },
      rowOperateSort: ['interactionManagement','videoManagement','viewTrainingRecords'],// 'manager',
      rowOperateView: [
        {
          key: "interactionManagement",
          custom: true,
          params: { children: "互动管理" },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "getUrl",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
               callback({
                liveType:record.liveType,
                id:record.id,
              })
              // window.open(record.loginUrl, '_blank')
              // return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.liveType ===1) {
              result.disabled = false
            }
            return result
          },
        },
        {
          key: "videoManagement",
          custom: true,
          params: { children: "视频管理" },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "getWebUploadBackPlayUrl",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              callback({
                liveType:record.liveType,
                id:record.id,
              })
              // window.open(record.loginUrl, '_blank')
              // return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true, hidden: true };
            if (record.record && record.record.liveType ===1) {
              result.disabled = false
              if ( record.record.liveVideoType ===4){
                result.hidden = false
              }
            }
            return result
          },
        },
        {
          key: "viewTrainingRecords",
          custom: true,
          params: { children: "查看参训记录"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/live/hostList/liveRecordList"
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.liveType !=4) {
              result.disabled = false
            }
            return result
          },
        },
      ],
      commonOperate: {}
    }
  }
};





const apis = (params = {}) => {
  return{
    list: {
      path: `${componentName}/hostListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, stateList: [1,2,3], ...(params || {}) }
      }
    },
    getUrl:{
      path: `${componentName}/getWebLiveUrl`,
      payload: {
        key: `${componentName}@getWebLiveUrl`,
        apiParams: {}
      }
    },
    getWebUploadBackPlayUrl:{
      path: `${componentName}/getWebUploadBackPlayUrl`,
      payload: {
        key: `${componentName}@getWebUploadBackPlayUrl`,
        apiParams: {}
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis: apis(args['params']),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
